import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader } from '../../Common/Loader'
import Pagination from '../../Common/Pagination'
import { getBidHistory } from '../../service/service'


const AutoDepositHistory = () => {
    const navigate = useNavigate()
    const [loader, setLoader] = useState(false)
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [bidHistoryList, setBidHistoryList] = useState([])
    const [search, setSearch] = useState('')
    const [depositFilter, setDepositFilter] = useState('AUTO')
    const [page, setPage] = useState(1)
    const PAGE_SIZE = 10

    useEffect(() => {
        handleGetBidHistory()
    }, [])

    const handleGetBidHistory = (sd, ed) => {
        setLoader(true)
        getBidHistory("admin-deposit-history", sd || undefined, ed || undefined).then((res) => {
            setBidHistoryList(res.data?.data)
            setLoader(false)
        }).catch((err) => {
            setLoader(false)
            alert(err || "something went wrong ")
        })
    }

    const handleReset = () => {
        setStartDate('')
        setEndDate('')
        setPage(1)
        handleGetBidHistory()
    }

    const filteredList = bidHistoryList?.filter(item => {
        const matchesSearch =
            (item?.user_id__first_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
            (item?.user_id__phone_number?.toString() || '').includes(search)
        const matchesType =
            depositFilter === 'ALL' ||
            (depositFilter === 'MANUAL' && item?.is_admin === true) ||
            (depositFilter === 'AUTO' && item?.is_admin !== true)
        return matchesSearch && matchesType
    })

    const totalAmount = filteredList?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0)
    const totalPages = Math.ceil((filteredList?.length || 0) / PAGE_SIZE)
    const pagedList = filteredList?.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

    return (
        <>
            {loader ? <Loader /> : null}
            <div className="content-wrapper">
                <div className='container-fluid'>
                    <div className='card p-3 flex align-center space-between mb-3'>
                        <h4 className="card-title text-left w-100 mb-4">Auto Deposit</h4>
                        <div className='row w-100 align-items-end'>
                            <div className='form-group col-md-3'>
                                <label className="mb-1" style={{fontSize:'16px'}}>Start Date</label>
                                <input type="date" className='form-control' value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                            </div>
                            <div className='form-group col-md-3'>
                                <label className="mb-1" style={{fontSize:'16px'}}>End Date</label>
                                <input type="date" className='form-control' value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                            </div>
                            <div className='form-group col-md-2'>
                                <button type="submit" className="btn btn-danger btn-block" onClick={() => { setPage(1); handleGetBidHistory(startDate, endDate) }}>Search</button>
                            </div>
                            <div className='form-group col-md-2'>
                                <button type="button" className="btn btn-secondary btn-block" onClick={handleReset}>Reset</button>
                            </div>
                        </div>
                    </div>

                    <div className='card p-3 flex align-center space-between'>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                            <h4 className="card-title text-left mb-0">
                                Auto Deposit History{filteredList?.length > 0 ? ` (Total: ₹${totalAmount})` : ''}
                            </h4>
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <select className="form-control" style={{ width: '140px' }} value={depositFilter} onChange={e => setDepositFilter(e.target.value)}>
                                    <option value="ALL">All</option>
                                    <option value="AUTO">Auto</option>
                                    <option value="MANUAL">Manual</option>
                                </select>
                                <input type="text" placeholder="Search name or mobile..." value={search} onChange={e => { setSearch(e.target.value); setPage(1) }} style={{ width: '220px', padding: '3px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '16px' }} />
                            </div>
                        </div>
                        <div className='row w-100'>
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0" cellPadding="0">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Mobile</th>
                                        <th>Amount</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pagedList?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <span className="link" style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => navigate('/user-details', { state: { id: item?.user_id__id } })}>
                                                    {item?.user_id__first_name || "NA"}
                                                </span>
                                                {item?.user_id__phone_number && (
                                                    <a href={`https://wa.me/91${item?.user_id__phone_number}`} target="_blank" rel="noreferrer" style={{ marginLeft: '6px', color: '#25D366' }}>
                                                        <i className="fa fa-whatsapp" style={{ fontSize: '16px' }}></i>
                                                    </a>
                                                )}
                                            </td>
                                            <td>{item?.user_id__phone_number || "NA"}</td>
                                            <td>{item?.amount}</td>
                                            <td><span className={`btnspan ${item?.is_admin ? 'danger' : 'success'}`}>{item?.is_admin ? 'Manual' : 'Auto'}</span></td>
                                            <td>{moment(item?.created_at).format("DD-MM-YYYY, h:mm a") || "NA"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="small text-muted mb-1 mt-2">Showing {filteredList?.length === 0 ? 0 : (page-1)*PAGE_SIZE+1}–{Math.min(page*PAGE_SIZE, filteredList?.length || 0)} of {filteredList?.length || 0} entries</div>
                            <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AutoDepositHistory



